import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Input, Row, Button, Modal, Image, Avatar, Col, ConfigProvider, Tabs, List, Collapse } from "antd";

import "./styles/Contactos.scss";

import iconos from "../componentes/IconosDeSitio";
import AgregarBlanco from "../Img/Iconos/AgregarBlanco.svg";

import { UseModal } from "../hooks/UseModal";

import InputAntd from "../componentes/GeneralComponents/InputAntd";
import SelectAntd from "../componentes/GeneralComponents/SelectAntd";

import {
  addContact_request,
  deleteContact_request,
  editContact_request,
} from "../services/contactos_services";
import { Loader } from "../componentes/GeneralComponents/Loader";
import LoaderModals from "../componentes/GeneralComponents/Loader_modals";
import LoaderCircle from "../componentes/GeneralComponents/LoaderCircle";

import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { CloseOutlined, KeyboardArrowDownRounded, KeyboardArrowUpRounded, Search } from "@mui/icons-material";
import TextAreaAntd from "../componentes/GeneralComponents/TextAreaAntd";
import Expresiones from "../utils/expresiones";

import useContactosData from '../hooks/Query/useContactosData';
import { normalizeText } from "../utils/utils";

import { showSnackbar } from "../redux/snackbarSlice";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import IconosDeSitio from "../componentes/IconosDeSitio";
import TabPane from "antd/es/tabs/TabPane";
import NewNavbar from "../componentes/GeneralComponents/Navbar_Nuevo";
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from "@ant-design/icons";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function NewContactos() {
  const location = useLocation();
  const [isOpenModalAddContacto, openModalAddContacto, CloseModalAddContacto] =
    UseModal(false);

  const [contactListFilter, setContactListFilter] = useState([]);
  const [contactListCopy, setContactListCopy] = useState([]);

  const [toggleState, setToggleState] = useState(1);

  const [AddProfileImage, setAddProfileImage] = useState({ name: "", url: "", file: "" });
  const [AddTipocontacto, setAddTipocontacto] = useState('');
  const [AddNombre, setAddNombre] = useState("");
  const [AddApellidoP, setAddApellidoP] = useState("");
  const [AddApellidoM, setAddApellidoM] = useState("");
  const [AddCelular, setAddCelular] = useState("");
  const [AddCorreo, setAddCorreo] = useState("");
  const [AddEspecialidad, setAddEspecialidad] = useState("");
  const [AddNotaContacto, setAddNotaContacto] = useState("");

  const [open, setOpen] = useState(false);
  const [typeMessage, setTypeMessage] = useState("");
  const [message, setMessage] = useState("");

  const [loader, setLoader] = useState(true);
  const [loaderAddContact, setLoaderAddContact] = useState(false);
  const [loaderEditContact, setLoaderEditContact] = useState(false);
  const [loaderDeleteContact, setLoaderDeleteContact] = useState(false);

  const [TipoUser, setTipoUser] = useState("");

  const [comboAddTipo, setComboAddTipo] = useState("true");

  const [MensajeAddNombre, setMensajeAddNombre] = useState("true");
  const [MensajeAddApellidoP, setMensajeAddApellidoP] = useState("true");
  const [MensajeAddApellidoM, setMensajeAddApellidoM] = useState("true");
  const [MensajeAddCelular, setMensajeAddCelular] = useState("true");
  const [MensajeAddCorreo, setMensajeAddCorreo] = useState("true");
  const [MensajeAddEspecialidad, setMensajeAddEspecialidad] = useState("true");

  const [EstatusModalEliminarContacto, setEstatusModalEliminarContacto] = useState(false);
  const [modal, ModalEliminarContacto] = Modal.useModal();

  const [editMode, setEditMode] = useState({}); // Para activar edición por item
  const [errors, setErrors] = useState({});     // Errores por item

  const Contactos = useContactosData();
  const userInfo = useSelector((state) => state.userInfo.usuario);
  const dispatch = useDispatch();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      title: location.pathname,
    });
    if (userInfo.Tipo) {
      setTipoUser(userInfo.Tipo)
    }
  }, [userInfo]);

  useEffect(() => {
    if (Contactos.data) {
      setContactListFilter(Contactos.data);
      setContactListCopy(Contactos.data);
      setLoader(false);
    }

  }, [Contactos.data])

  const saveContact = async (e) => {
    e.preventDefault();
    setLoaderAddContact(true);
    let data = new FormData();
    if (!AddTipocontacto) {
      dispatch(showSnackbar({
        show: true,
        text: 'Selecciona el tipo de contacto',
        type: 'warning'
      }));
      setComboAddTipo("false");
      setLoaderAddContact(false);
      return;
    }

    if (
      (!!AddNombre && MensajeAddNombre === "true" &&
        !!AddApellidoP && MensajeAddApellidoP === "true" &&
        MensajeAddApellidoM === "true" &&
        MensajeAddCelular === "true" &&
        MensajeAddCorreo === "true"
      )
    ) {
      if (AddTipocontacto === "1" && (!AddEspecialidad && MensajeAddEspecialidad === "true")) {
        setMensajeAddEspecialidad("false");
        dispatch(showSnackbar({
          show: true,
          text: 'Selecciona la especialidad.',
          type: 'warning'
        }));
        setLoaderAddContact(false);
        return;
      }

      data.append("Nombre", AddNombre);
      data.append("ApellidoPaterno", AddApellidoP);
      data.append("ApellidoMaterno", AddApellidoM);
      data.append("Celular", AddCelular);
      data.append("Email", AddCorreo);
      data.append("Tipo", AddTipocontacto === "1" ? "Médico" : "Paciente");
      data.append("especialidad", AddEspecialidad);
      data.append("Nota", AddNotaContacto);

      if (AddProfileImage.file !== "") {
        data.append("Imagen", AddProfileImage.file, AddProfileImage.name);
      }

      let response = await addContact_request(data);
      if (response.ok) {
        Contactos.refetch();
        dispatch(showSnackbar({
          show: true,
          text: 'Contacto guardado',
          type: 'success'
        }));
        CloseModalAddContacto(false);
        clean_inputsAdd();

      } else {
        dispatch(showSnackbar({
          show: true,
          text: response.mensaje,
          type: 'error'
        }));
      }
      setLoaderAddContact(false);
    }
    else {
      dispatch(showSnackbar({
        show: true,
        text: 'Faltan campos por completar',
        type: 'warning'
      }))
      if (!!!AddNombre) {
        setMensajeAddNombre("false");
      }

      if (!!!AddApellidoP) {
        setMensajeAddApellidoP("false");
      }
      setLoaderAddContact(false);
    }
  }

  async function deleteContact(id) {
    setLoaderDeleteContact(true);
    let response = await deleteContact_request(id);

    if (response.ok) {
      Contactos.refetch();
      dispatch(showSnackbar({
        show: true,
        text: 'Contacto eliminado',
        type: 'success'
      }))
    } else {
      dispatch(showSnackbar({
        show: true,
        text: response.mensaje,
        type: 'error'
      }))
    }
    setLoaderDeleteContact(false);
    return;
  }

  function clean_inputsAdd() {
    setAddProfileImage({ name: "", url: "", file: "" });
    setAddTipocontacto(null);
    setAddNombre("");
    setAddApellidoP("");
    setAddApellidoM("");
    setAddCelular("");
    setAddCorreo("");
    setComboAddTipo("true");
  }

  const filterList = (searchText) => {
    const normalizedSearchText = normalizeText(searchText.toLowerCase());

    const filter = Contactos.data.filter((contacto) => {
      const normalizedName = normalizeText(`${contacto.Nombre} ${contacto.ApellidoPaterno}${!!contacto.ApellidoMaterno ? !!contacto.ApellidoMaterno.trim() ? ` ${contacto.ApellidoMaterno}` : "" : ""}`.toLowerCase());
      const normalizedEmail = normalizeText(contacto.Email ? contacto.Email.toLowerCase() : "");
      const normalizedPhone = normalizeText(contacto.Celular ? contacto.Celular.toLowerCase() : "");

      return (
        normalizedName.includes(normalizedSearchText) ||
        normalizedEmail.includes(normalizedSearchText) ||
        normalizedPhone.includes(normalizedSearchText)
      );
    });

    setContactListFilter(filter);

  }

  const newEditContact = async (e, id) => {
    e.preventDefault();
    const contactToEdit = contactListFilter.filter(contacto => id.includes(contacto.IdContacto))[0];
    setLoaderEditContact(true);

    if (contactToEdit.Type &&
      contactToEdit.Nombre && errors[id].Nombre === "true" &&
      contactToEdit.ApellidoPaterno && errors[id].ApellidoPaterno === "true" &&
      errors[id].ApellidoMaterno === "true" &&
      errors[id].Celular === "true" &&
      errors[id].Email === "true"
    ) {
      let data = new FormData();
      data.append("Nombre", contactToEdit.Nombre);
      data.append("ApellidoPaterno", contactToEdit.ApellidoPaterno);
      data.append("ApellidoMaterno", contactToEdit.ApellidoMaterno ? contactToEdit.ApellidoMaterno : "");
      data.append("Celular", contactToEdit.Celular ? contactToEdit.Celular : "");
      data.append("Email", contactToEdit.Email ? contactToEdit.Email : "");
      data.append("Tipo", contactToEdit.Type === 1 ? "Médico" : contactToEdit.Type === 3 || contactToEdit.Type === 5 ? "Paciente" : "Asistente");
      data.append("Nota", contactToEdit.Nota);
      if (contactToEdit.NuevaImagen !== undefined) {
        data.append("Imagen", contactToEdit.NuevaImagen.file, contactToEdit.NuevaImagen.name);
      }

      let response = await editContact_request(data, id);
      if (response.ok) {
        Contactos.refetch();
        setEditMode((prev) => ({ ...prev, [id]: false }));
        setErrors(prev => {
          const nuevo = { ...prev };
          delete nuevo[id];
          return nuevo;
        });
        dispatch(showSnackbar({
          show: true,
          text: 'Contacto editado',
          type: "success",
        }));
      } else {
        dispatch(showSnackbar({
          show: true,
          text: response.mensaje,
          type: "error",
        }));
      }
    } else {
      if (!contactToEdit.Nombre) {
        setErrors((prev) => ({
          ...prev,
          [id]: { ...prev[id], Nombre: "false" },
        }));
      }

      if (!contactToEdit.ApellidoPaterno) {
        setErrors((prev) => ({
          ...prev,
          [id]: { ...prev[id], ApellidoPaterno: "false" },
        }));
      }

      if (!contactToEdit.Type) {
        setErrors((prev) => ({
          ...prev,
          [id]: { ...prev[id], Type: "false" },
        }));
      }

      dispatch(showSnackbar({
        show: true,
        text: 'Faltan campos por completar',
        type: "warning",
      }));
    }
    setLoaderEditContact(false);
    return;
  };

  function cancelEdit(item) {

    // setContactListFilter(contactListCopy);
    const cancelEdit = contactListCopy.map(contacto => {
      if (contacto.IdContacto === item.IdContacto) {
        return { ...contacto, item };
      }
      return contacto;
    });
    setContactListFilter(cancelEdit); // actualiza el estado con el nuevo array
    setEditMode((prev) => ({ ...prev, [item.IdContacto]: false }));
    setErrors(prev => {
      const nuevo = { ...prev };
      delete nuevo[item.IdContacto];
      return nuevo;
    });
  };

  const handleEdit = (id) => {
    setEditMode((prev) => ({ ...prev, [id]: true }));
    setErrors((prev) => (
      {
        ...prev,
        [id]: {
          Nombre: "true",
          ApellidoPaterno: "true",
          ApellidoMaterno: "true",
          Type: "true",
          Celular: "true",
          Email: "true",
          Nota: "true"
        },
      }
    )
    );
  };

  const getContactsByType = (types) => {
    let resultContactos = contactListFilter.filter(contacto => types.includes(contacto.Type));
    return resultContactos;
  }

  const confirmEliminarContacto = (contacto) => {
    modal.confirm({
      title: "¿Desea eliminar este contacto?",
      okText: "Eliminar",
      cancelText: "Cancelar",
      onOk: () => deleteContact(contacto.IdContacto),
      onCancel: () => {
        setEstatusModalEliminarContacto(false);
      },
      okButtonProps: { className: "roundedButtonBlue buttons-delete-contact", loading: loaderDeleteContact },
      cancelButtonProps: { className: "roundedButtonWhite buttons-delete-contact", loading: loaderDeleteContact },
      open: EstatusModalEliminarContacto,
      icon: <ExclamationCircleOutlined />,
      content: (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
          <div>
            <Avatar size={50} src={contacto.Imagen_url !== null ? "https://" + contacto.Imagen_url : IconosDeSitio[0]} />
            <p>{contacto.Nombre + " " + contacto.ApellidoPaterno + " " + contacto.ApellidoMaterno}</p>
          </div>
        </div>
      ),
    });
  }

  const changeValueInput = (id, value, inputName) => {
    const editInput = contactListFilter.map(contacto => {
      if (contacto.IdContacto === id) {
        switch (inputName) {
          case "Nombre":
            return { ...contacto, Nombre: value };
          case "ApellidoPaterno":
            return { ...contacto, ApellidoPaterno: value };
          case "ApellidoMaterno":
            return { ...contacto, ApellidoMaterno: value };
          case "Type":
            return { ...contacto, Type: value };
          case "Celular":
            return { ...contacto, Celular: value };
          case "Email":
            return { ...contacto, Email: value };
          case "Nota":
            return { ...contacto, Nota: value };
        }
      }
      return contacto;
    });
    setContactListFilter(editInput); // actualiza el estado con el nuevo array
  }

  const manageError = (inputName, value, id) => {
    setErrors((prev) => {
      switch (inputName) {
        case "Nombre":
          return {
            ...prev,
            [id]: { ...prev[id], Nombre: value },
          }
        case "ApellidoPaterno":
          return {
            ...prev,
            [id]: { ...prev[id], ApellidoPaterno: value },
          }
        case "ApellidoMaterno":
          return {
            ...prev,
            [id]: { ...prev[id], ApellidoMaterno: value },
          }
        case "Type":
          return {
            ...prev,
            [id]: { ...prev[id], Type: value },
          }
        case "Celular":
          return {
            ...prev,
            [id]: { ...prev[id], Celular: value },
          };
        case "Email":
          return {
            ...prev,
            [id]: { ...prev[id], Email: value },
          };
        case "Nota":
          return {
            ...prev,
            [id]: { ...prev[id], Nota: value },
          };
      }
    }
    );
  }

  return (
    <Stack style={{ background: "white", height: "100dvh" }}>
      <NewNavbar
        mensajesError={{
          setOpen: setOpen,
          setTypeMessage: setTypeMessage,
          setMessage: setMessage,
        }}
        modulo={"Contactos"}
        searchBar={
          <Row style={{ background: "white", marginBottom: "20px" }}>
            <Col sm={{ flex: "50%" }} className="col-input-search-contact">
              <div className="div-input-loader">
                <Input
                  prefix={<Search style={{ color: "#d7d7d7", width: "18px" }} />}
                  className="input-search-contact"
                  // style={{ width: "50%" }}
                  placeholder="Nombre, correo, celular"
                  type="text"
                  onChange={(e) => filterList(e.target.value)}
                />
                <div style={{ marginLeft: 50, height: '50%', width: 28 }}>
                  {!Contactos.isLoading && Contactos.isFetching ?
                    <LoaderCircle Width={28} Height={28} /> : <></>
                  }
                </div>
              </div>
            </Col>
            <Col sm={{ flex: "50%" }} className="col-button-new-contact">
              <Button className="roundedButtonBlue button-new-contact" onClick={() => {
                openModalAddContacto(true);
                clean_inputsAdd();
              }}>
                <Row style={{ gap: ".5rem", width: "100%", color: "white", justifyContent: "center", alignItems: "center" }}>
                  Nuevo
                  <img style={{ width: "12px" }} src={AgregarBlanco} alt="" />
                </Row>
              </Button>
            </Col>
          </Row>
        }
      />

      <div style={{ display: "flex", justifyContent: "center" }}>
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                cardBg: "#5BC4D2"
              }
            }
          }}
        >
          <Tabs
            defaultActiveKey="1"
            className="custom-tabs"
            type="card"
            onChange={(key) => setToggleState(key)}
          >
            {/* TAB DE PACIENTES */}
            <TabPane
              key="1"
              className="custome-tab-pane tab-pane-1"
              tab={<div className="custom-tab tab-1">Pacientes</div>}
            >
              {loader ? (
                <Loader style={{ width: "100%", height: "53dvh" }} height="53dvh" />
              ) : (
                <div
                  id="scrollableDiv"
                  className="scrollable-div-list"
                >
                  <List
                    dataSource={getContactsByType([3, 5])}
                    loading={loader}
                    renderItem={(item, index) => (
                      <List.Item key={`paciente_${index}`} style={{ padding: "5px 0" }}>
                        <Collapse
                          expandIcon={({ isActive }) => isActive ?
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "25px", height: "25px", borderRadius: "20px", border: "2px solid #5BC4D2" }}>
                              <KeyboardArrowUpRounded style={{ color: "#5BC4D2" }} />
                            </div>
                            :
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "25px", height: "25px", borderRadius: "20px", border: "2px solid #5BC4D2" }}>
                              <KeyboardArrowDownRounded style={{ color: "#5BC4D2" }} />
                            </div>

                          }
                          expandIconPosition="end"
                          style={{ width: "100%", background: "white" }}
                          items={[
                            {
                              key: item.IdContacto,
                              label: (
                                <List.Item.Meta
                                  style={{ padding: "0 15px" }}
                                  avatar={<Avatar size={50} src={item.Imagen_url !== null ? "https://" + item.Imagen_url : IconosDeSitio[0]} />}
                                  title={<b>{item.Nombre + " " + item.ApellidoPaterno + " " + item.ApellidoMaterno}</b>}
                                  description={<span>
                                    <b style={{ color: "#5BC4D2" }}>{item.Tipo}&nbsp;{item.YgiaUser}</b>
                                  </span>}

                                />
                              ),
                              styles: { body: { background: "var(--Bright-blue, #B7E7ED)" } },
                              children: (
                                <div key={item.IdContacto}>
                                  <Row style={{ marginBottom: "15px" }}>
                                    <Col sm={{ flex: "50%" }} style={{ padding: "0 7px" }}>
                                      <h2 style={{ color: "gray" }}>Detalle de contacto</h2>
                                    </Col>
                                    <Col sm={{ flex: "50%" }} style={{ display: "flex", justifyContent: "end", padding: "0 7px" }}>
                                      <Row style={{ width: "70px", justifyContent: "space-between" }}>
                                        {!editMode[item.IdContacto] && (
                                          <EditOutlined size={40} style={{ color: "gray", fontSize: "25px", cursor: "pointer" }} onClick={() => {
                                            handleEdit(item.IdContacto);
                                          }} />
                                        )}
                                        <DeleteOutlined size={40} style={{ color: "gray", fontSize: "25px", cursor: "pointer" }} onClick={() => {
                                          confirmEliminarContacto(item);
                                        }} />
                                      </Row>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm={{ flex: "50%" }} style={{ padding: "0 7px" }}>
                                      <Row style={{ alignItems: "center" }}>
                                        <label htmlFor={`imagenContacto_${item.IdContacto}`}>
                                          <Avatar size={70} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                            className='GeneralNoImage'
                                            src={
                                              !editMode[item.IdContacto] === true ?
                                                <Image
                                                  src={
                                                    item.NuevaImagen !== undefined
                                                      ? item.NuevaImagen.url
                                                      : !!item.Imagen_url
                                                        ? "https://" + item.Imagen_url
                                                        : iconos[19]
                                                  }
                                                /> : <img
                                                  src={
                                                    item.NuevaImagen !== undefined
                                                      ? item.NuevaImagen.url
                                                      : !!item.Imagen_url
                                                        ? "https://" + item.Imagen_url
                                                        : iconos[19]
                                                  }
                                                />

                                            } />
                                        </label>
                                        {(item.YgiaUser === "Sin Ygia" &&
                                          editMode[item.IdContacto]) && (
                                            <input
                                              type="file"
                                              id={`imagenContacto_${item.IdContacto}`}
                                              accept="/image/x-PNG,image/jpeg"
                                              style={{ display: "none" }}
                                              onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file && file.type.substring(0, 5) === "image") {
                                                  const editImagen = contactListFilter.map(contacto => {
                                                    if (contacto.IdContacto === item.IdContacto) {
                                                      return {
                                                        ...contacto, NuevaImagen: {
                                                          name: e.target.value,
                                                          url: URL.createObjectURL(e.target.files[0]),
                                                          file: e.target.files[0],
                                                        }
                                                      };
                                                    }
                                                    return contacto;
                                                  });
                                                  setContactListFilter(editImagen); // actualiza el estado con el nuevo array
                                                }
                                              }}
                                            />
                                          )}
                                        <div style={{ marginLeft: "15px" }}>
                                          <h4 style={{ textAlign: "center", marginTop: '10px', color: "gray" }}>
                                            {"ID YGIA: " + item.IdContacto}
                                          </h4>
                                        </div>
                                      </Row>

                                      <InputAntd
                                        value={item.Nombre}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, value, "Nombre")
                                        }}
                                        label="Nombre:"
                                        style={{ margin: "1% 0", background: "white" }}
                                        placeholder="Escribe tu nombre"
                                        setStateError={(value) => {
                                          manageError("Nombre", value, item.IdContacto);
                                        }}
                                        textError={["Debe escribir un nombre", "Solo se permiten letras (max. 20 caracteres)"]}
                                        type="text"
                                        valueError={errors[item.IdContacto]?.Nombre}
                                        vacio={false}
                                        disabled={!editMode[item.IdContacto]}
                                        expresionRegular={Expresiones.Letras}
                                        maxLength={40}
                                      />

                                      <InputAntd
                                        value={item.ApellidoPaterno}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, value, "ApellidoPaterno")
                                        }}
                                        label="Apellido paterno:"
                                        style={{ margin: "1% 0", background: "white" }}
                                        placeholder="Escribe tu primer apellido"
                                        setStateError={(value) => {
                                          manageError("ApellidoPaterno", value, item.IdContacto);
                                        }}
                                        textError={["Debe escribir un apellido", "Solo se permiten letras (max. 20 caracteres)"]}
                                        type="text"
                                        valueError={errors[item.IdContacto]?.ApellidoPaterno}
                                        vacio={false}
                                        disabled={!editMode[item.IdContacto]}
                                        expresionRegular={Expresiones.Letras}
                                        maxLength={20}
                                      />

                                      <InputAntd
                                        value={item.ApellidoMaterno}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, value, "ApellidoMaterno")
                                        }}
                                        label="Apellido materno:"
                                        style={{ margin: "1% 0", background: "white" }}
                                        placeholder="Escribe tu segundo apellido"
                                        setStateError={(value) => {
                                          manageError("ApellidoMaterno", value, item.IdContacto);
                                        }}
                                        textError={["", "Solo se permiten letras (max. 20 caracteres)"]}
                                        type="text"
                                        valueError={errors[item.IdContacto]?.ApellidoMaterno}
                                        vacio={true}
                                        disabled={!editMode[item.IdContacto]}
                                        expresionRegular={Expresiones.Letras}
                                        maxLength={20}
                                      />
                                    </Col>
                                    <Col sm={{ flex: "50%" }} style={{ padding: "0 7px" }}>
                                      <SelectAntd
                                        id={`type-contact-${index}`}
                                        label="Tipo de contacto:"
                                        value={item.Type != null ? item.Type.toString() : ""}
                                        style={{ width: "100%", margin: "0 0 5px 0", background: "white" }}
                                        placeholder="Tipo de contacto"
                                        options={[
                                          { value: "1", label: "Médico" },
                                          { value: "3", label: "Paciente" },
                                        ]}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, parseInt(value), "Type")
                                        }}
                                        valueError={errors[item.IdContacto]?.Type}
                                        disabled={item.Type === 4 || item.YgiaUser === "Con Ygia" ? true : !editMode[item.IdContacto]}
                                      />


                                      <InputAntd
                                        value={item.Celular}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, value, "Celular")
                                        }}
                                        label="Celular:"
                                        id="celular"
                                        style={{ margin: "1% 0", background: "white" }}
                                        placeholder="Escribe tu celular"
                                        setStateError={(value) => {
                                          manageError("Celular", value, item.IdContacto);
                                        }}
                                        textError={["", "Celular solo puede contener numeros", "Celular debe contener 10 dígitos"]}
                                        type="text"
                                        valueError={errors[item.IdContacto]?.Celular}
                                        vacio={true}
                                        disabled={!editMode[item.IdContacto]}
                                        expresionRegular={Expresiones.Numeros}
                                        maxLength={10}
                                      />

                                      <InputAntd
                                        value={item.Email}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, value, "Email")
                                        }}
                                        label="Correo:"
                                        style={{ margin: "1% 0", background: "white" }}
                                        placeholder="Escribe tu correo eléctronico"
                                        setStateError={(value) => {
                                          manageError("Email", value, item.IdContacto);
                                        }}
                                        textError={["", "Formato incorrecto"]}
                                        type="text"
                                        valueError={errors[item.IdContacto]?.Email}
                                        vacio={true}
                                        disabled={!editMode[item.IdContacto]}
                                        expresionRegular={Expresiones.Correo}
                                      />

                                      <TextAreaAntd
                                        label="Comentarios o notas:"
                                        value={item.Nota}
                                        placeholder="Escriba un comentario o nota (opcional)"
                                        style={{
                                          marginTop: "7px",
                                          fontFamily: "sans-serif",
                                          background: "white"
                                        }}
                                        columns="30"
                                        autoSize={true}
                                        disabled={!editMode[item.IdContacto]}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, value, "Nota")
                                        }}
                                      />
                                    </Col>

                                    {editMode[item.IdContacto] && (
                                      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", width: "100%" }}>
                                        <Button
                                          className="roundedButtonBlue buttons-add-contact"
                                          style={{ marginRight: "10px" }}
                                          loading={loaderEditContact}
                                          onClick={(e) => { newEditContact(e, item.IdContacto) }}
                                        >
                                          Guardar
                                        </Button>

                                        <Button
                                          className="roundedButtonWhite buttons-add-contact"
                                          style={{ marginLeft: "10px" }}
                                          loading={loaderEditContact}
                                          onClick={() => { cancelEdit(item); }}
                                        >
                                          Cancelar
                                        </Button>
                                      </div>
                                    )}
                                  </Row>
                                </div>
                              )

                            }
                          ]}
                        />
                      </List.Item>

                    )}
                  />
                </div>
              )}
            </TabPane>
            {/* TAB DE MEDICOS */}
            <TabPane
              key="2"
              className="custome-tab-pane tab-pane-2"
              tab={<div className="custom-tab tab-2">Médicos</div>}
            >
              {loader ? (<Loader style={{ width: "100%", height: "53dvh" }} height="53dvh" />) : (
                <div
                  id="scrollableDiv"
                  className="scrollable-div-list"
                >
                  <List
                    dataSource={getContactsByType([1])}
                    renderItem={(item, index) => (
                      <List.Item key={`medico_${index}`}>
                        <Collapse
                          expandIcon={({ isActive }) => isActive ?
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "25px", height: "25px", borderRadius: "20px", border: "2px solid #5BC4D2" }}>
                              <KeyboardArrowUpRounded style={{ color: "#5BC4D2" }} />
                            </div>
                            :
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "25px", height: "25px", borderRadius: "20px", border: "2px solid #5BC4D2" }}>
                              <KeyboardArrowDownRounded style={{ color: "#5BC4D2" }} />
                            </div>
                          }

                          expandIconPosition="end"
                          style={{ width: "100%", background: "white" }}

                          items={[
                            {
                              key: item.IdContacto,
                              label: (
                                <List.Item.Meta
                                  style={{ padding: "0 15px" }}
                                  avatar={<Avatar size={50} src={item.Imagen_url !== null ? "https://" + item.Imagen_url : IconosDeSitio[0]} />}
                                  title={<b>{item.Nombre + " " + item.ApellidoPaterno + " " + item.ApellidoMaterno}</b>}
                                  description={<span>
                                    <b style={{ color: "#5BC4D2" }}>{item.Tipo}&nbsp;{item.YgiaUser}</b>
                                  </span>}

                                />
                              ),
                              // styles: { body: { background: "#FFDAB3" } },#CFE9FF
                              styles: { body: { background: "#CFE9FF" } },
                              children: (
                                <div>
                                  <Row style={{ marginBottom: "15px" }}>
                                    <Col sm={{ flex: "50%" }} style={{ padding: "0 7px" }}>
                                      <h2 style={{ color: "gray" }}>Detalle de contacto</h2>
                                    </Col>
                                    <Col sm={{ flex: "50%" }} style={{ display: "flex", justifyContent: "end", padding: "0 7px" }}>
                                      <Row style={{ width: "70px", justifyContent: "space-between" }}>
                                        {!editMode[item.IdContacto] && (
                                          <EditOutlined size={40} style={{ color: "gray", fontSize: "25px", cursor: "pointer" }} onClick={() => {
                                            handleEdit(item.IdContacto);
                                          }} />
                                        )}
                                        <DeleteOutlined size={40} style={{ color: "gray", fontSize: "25px", cursor: "pointer" }} onClick={() => {
                                          confirmEliminarContacto(item);
                                        }} />
                                      </Row>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm={{ flex: "50%" }} style={{ padding: "0 7px" }}>
                                      <Row style={{ alignItems: "center" }}>
                                        <label htmlFor={`imagenContacto_${item.IdContacto}`}>
                                          <Avatar size={70} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                            className='GeneralNoImage'
                                            src={
                                              !editMode[item.IdContacto] === true ?
                                                <Image
                                                  src={
                                                    item.NuevaImagen !== undefined
                                                      ? item.NuevaImagen.url
                                                      : !!item.Imagen_url
                                                        ? "https://" + item.Imagen_url
                                                        : iconos[19]
                                                  }
                                                /> : <img
                                                  src={
                                                    item.NuevaImagen !== undefined
                                                      ? item.NuevaImagen.url
                                                      : !!item.Imagen_url
                                                        ? "https://" + item.Imagen_url
                                                        : iconos[19]
                                                  }
                                                />

                                            } />
                                        </label>
                                        {(item.YgiaUser === "Sin Ygia" &&
                                          editMode[item.IdContacto]) && (
                                            <input
                                              type="file"
                                              id={`imagenContacto_${item.IdContacto}`}
                                              accept="/image/x-PNG,image/jpeg"
                                              style={{ display: "none" }}
                                              onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file && file.type.substring(0, 5) === "image") {
                                                  const editImagen = contactListFilter.map(contacto => {
                                                    if (contacto.IdContacto === item.IdContacto) {
                                                      return {
                                                        ...contacto, NuevaImagen: {
                                                          name: e.target.value,
                                                          url: URL.createObjectURL(e.target.files[0]),
                                                          file: e.target.files[0],
                                                        }
                                                      };
                                                    }
                                                    return contacto;
                                                  });
                                                  setContactListFilter(editImagen); // actualiza el estado con el nuevo array
                                                }
                                              }}
                                            />
                                          )}
                                        <div style={{ marginLeft: "15px" }}>
                                          <h4 style={{ textAlign: "center", marginTop: '10px', color: "gray" }}>
                                            {"ID YGIA: " + item.IdContacto}
                                          </h4>
                                        </div>
                                      </Row>

                                      <InputAntd
                                        value={item.Nombre}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, value, "Nombre")
                                        }}
                                        label="Nombre:"
                                        style={{ margin: "1% 0", background: "white" }}
                                        placeholder="Escribe tu nombre"
                                        setStateError={(value) => {
                                          manageError("Nombre", value, item.IdContacto);
                                        }}
                                        textError={["Debe escribir un nombre", "Solo se permiten letras (max. 20 caracteres)"]}
                                        type="text"
                                        valueError={errors[item.IdContacto]?.Nombre}
                                        vacio={false}
                                        disabled={!editMode[item.IdContacto]}
                                        expresionRegular={Expresiones.Letras}
                                        maxLength={40}
                                      />

                                      <InputAntd
                                        value={item.ApellidoPaterno}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, value, "ApellidoPaterno")
                                        }}
                                        label="Apellido paterno:"
                                        style={{ margin: "1% 0", background: "white" }}
                                        placeholder="Escribe tu primer apellido"
                                        setStateError={(value) => {
                                          manageError("ApellidoPaterno", value, item.IdContacto);
                                        }}
                                        textError={["Debe escribir un apellido", "Solo se permiten letras (max. 20 caracteres)"]}
                                        type="text"
                                        valueError={errors[item.IdContacto]?.ApellidoPaterno}
                                        vacio={false}
                                        disabled={!editMode[item.IdContacto]}
                                        expresionRegular={Expresiones.Letras}
                                        maxLength={20}
                                      />

                                      <InputAntd
                                        value={item.ApellidoMaterno}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, value, "ApellidoMaterno")
                                        }}
                                        label="Apellido materno:"
                                        style={{ margin: "1% 0", background: "white" }}
                                        placeholder="Escribe tu segundo apellido"
                                        setStateError={(value) => {
                                          manageError("ApellidoMaterno", value, item.IdContacto);
                                        }}
                                        textError={["", "Solo se permiten letras (max. 20 caracteres)"]}
                                        type="text"
                                        valueError={errors[item.IdContacto]?.ApellidoMaterno}
                                        vacio={true}
                                        disabled={!editMode[item.IdContacto]}
                                        expresionRegular={Expresiones.Letras}
                                        maxLength={20}
                                      />
                                    </Col>
                                    <Col sm={{ flex: "50%" }} style={{ padding: "0 7px" }}>
                                      <SelectAntd
                                        label="Tipo de contacto:"
                                        value={item.Type !== null ? item.Type.toString() : null}
                                        style={{ width: "100%", margin: "0 0 5px 0", background: "white" }}
                                        placeholder="Tipo de contacto"
                                        options={[
                                          { value: "1", label: "Médico" },
                                          { value: "3", label: "Paciente" },
                                        ]}
                                        setStateValue={(value) => { changeValueInput(item.IdContacto, parseInt(value), "Type"); }}
                                        valueError={errors[item.IdContacto]?.Type}
                                        disabled={item.Type === 4 || item.YgiaUser === "Con Ygia" ? true : !editMode[item.IdContacto]}
                                      />


                                      <InputAntd
                                        value={item.Celular}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, value, "Celular")
                                        }}
                                        label="Celular:"
                                        id="celular"
                                        style={{ margin: "1% 0", background: "white" }}
                                        placeholder="Escribe tu celular"
                                        setStateError={(value) => {
                                          manageError("Celular", value, item.IdContacto);
                                        }}
                                        textError={["", "Celular solo puede contener numeros", "Celular debe contener 10 dígitos"]}
                                        type="text"
                                        valueError={errors[item.IdContacto]?.Celular}
                                        vacio={true}
                                        disabled={!editMode[item.IdContacto]}
                                        expresionRegular={Expresiones.Numeros}
                                        maxLength={10}
                                      />

                                      <InputAntd
                                        value={item.Email}
                                        setStateValue={(value) => {
                                          changeValueInput(item.IdContacto, value, "Celular")
                                        }}
                                        label="Correo:"
                                        style={{ margin: "1% 0", background: "white" }}
                                        placeholder="Escribe tu correo eléctronico"
                                        setStateError={(value) => {
                                          manageError("Email", value, item.IdContacto);
                                        }}
                                        textError={["", "Formato incorrecto"]}
                                        type="text"
                                        valueError={errors[item.IdContacto]?.Email}
                                        vacio={true}
                                        disabled={!editMode[item.IdContacto]}
                                        expresionRegular={Expresiones.Correo}
                                      />

                                      <TextAreaAntd
                                        label="Comentarios o notas:"
                                        value={item.Nota}
                                        placeholder="Escriba un comentario o nota (opcional)"
                                        style={{
                                          marginTop: "7px",
                                          fontFamily: "sans-serif",
                                          background: "white"
                                        }}
                                        columns="30"
                                        autoSize={true}
                                        disabled={!editMode[item.IdContacto]}
                                        setStateValue={(value) => { changeValueInput(item.IdContacto, value, "Nota"); }}
                                      />
                                    </Col>

                                    {editMode[item.IdContacto] && (
                                      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", width: "100%" }}>
                                        <Button
                                          className="roundedButtonBlue buttons-add-contact"
                                          style={{ marginRight: "10px" }}
                                          loading={loaderEditContact}
                                          onClick={(e) => { newEditContact(e, item.IdContacto) }}
                                        >
                                          Guardar
                                        </Button>

                                        <Button
                                          className="roundedButtonWhite buttons-add-contact"
                                          style={{ marginLeft: "10px" }}
                                          loading={loaderEditContact}
                                          onClick={() => { cancelEdit(item); }}
                                        >
                                          Cancelar
                                        </Button>
                                      </div>
                                    )}
                                  </Row>
                                </div>
                              )

                            }
                          ]}
                        />
                      </List.Item>
                    )}
                  />
                </div>
              )}
            </TabPane>
            {/* TAB DE ASISTENTES */}
            {TipoUser === 1 && (
              <TabPane
                key="3"
                className="custome-tab-pane tab-pane-3"
                tab={<div className="custom-tab tab-3">Asistentes</div>}
              >
                <div
                  id="scrollableDiv"
                  className="scrollable-div-list"
                >
                  {loader ? (<Loader style={{ width: "100%", height: "53dvh" }} height="53dvh" />) : (
                    <List
                      dataSource={getContactsByType([4])}
                      renderItem={(item, index) => (
                        <List.Item key={`asistente_${index}`}>
                          <Collapse
                            expandIcon={({ isActive }) => isActive ?
                              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "25px", height: "25px", borderRadius: "20px", border: "2px solid #5BC4D2" }}>
                                <KeyboardArrowUpRounded style={{ color: "#5BC4D2" }} />
                              </div>
                              :
                              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "25px", height: "25px", borderRadius: "20px", border: "2px solid #5BC4D2" }}>
                                <KeyboardArrowDownRounded style={{ color: "#5BC4D2" }} />
                              </div>

                            }

                            expandIconPosition="end"
                            style={{ width: "100%", background: "white" }}

                            items={[
                              {
                                key: item.IdContacto,
                                label: (
                                  <List.Item.Meta
                                    style={{ padding: "0 15px" }}
                                    avatar={<Avatar size={50} src={item.Imagen_url !== null ? "https://" + item.Imagen_url : IconosDeSitio[0]} />}
                                    title={<b>{item.Nombre + " " + item.ApellidoPaterno + " " + item.ApellidoMaterno}</b>}
                                    description={<span>
                                      <b style={{ color: "#F7B369" }}>{item.Tipo}&nbsp;{item.YgiaUser}</b>
                                    </span>}

                                  />
                                ),
                                styles: { body: { background: "#FFDAB3" } },
                                children: (
                                  <div>
                                    <Row style={{ marginBottom: "15px" }}>
                                      <Col sm={{ flex: "50%" }} style={{ padding: "0 7px" }}>
                                        <h2 style={{ color: "gray" }}>Detalle de contacto</h2>
                                      </Col>
                                      <Col sm={{ flex: "50%" }} style={{ display: "flex", justifyContent: "end", padding: "0 7px" }}>
                                        <Row style={{ width: "70px", justifyContent: "space-between" }}>
                                          {!editMode[item.IdContacto] && (
                                            <EditOutlined size={40} style={{ color: "gray", fontSize: "25px", cursor: "pointer" }} onClick={() => {
                                              handleEdit(item.IdContacto);
                                            }} />
                                          )}
                                          <DeleteOutlined size={40} style={{ color: "gray", fontSize: "25px", cursor: "pointer" }} onClick={() => {
                                            confirmEliminarContacto(item);
                                          }} />
                                        </Row>
                                      </Col>
                                    </Row>

                                    <Row>
                                      <Col sm={{ flex: "50%" }} style={{ padding: "0 7px" }}>
                                        <Row style={{ alignItems: "center" }}>
                                          <label htmlFor={`imagenContacto_${item.IdContacto}`}>
                                            <Avatar size={70} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                              className='GeneralNoImage'
                                              src={
                                                !editMode[item.IdContacto] === true ?
                                                  <Image
                                                    src={
                                                      item.NuevaImagen !== undefined
                                                        ? item.NuevaImagen.url
                                                        : !!item.Imagen_url
                                                          ? "https://" + item.Imagen_url
                                                          : iconos[19]
                                                    }
                                                  /> : <img
                                                    src={
                                                      item.NuevaImagen !== undefined
                                                        ? item.NuevaImagen.url
                                                        : !!item.Imagen_url
                                                          ? "https://" + item.Imagen_url
                                                          : iconos[19]
                                                    }
                                                  />

                                              } />
                                          </label>
                                          {(item.YgiaUser === "Sin Ygia" &&
                                            editMode[item.IdContacto]) && (
                                              <input
                                                type="file"
                                                id={`imagenContacto_${item.IdContacto}`}
                                                accept="/image/x-PNG,image/jpeg"
                                                style={{ display: "none" }}
                                                onChange={(e) => {
                                                  const file = e.target.files[0];
                                                  if (file && file.type.substring(0, 5) === "image") {
                                                    const editImagen = contactListFilter.map(contacto => {
                                                      if (contacto.IdContacto === item.IdContacto) {
                                                        return {
                                                          ...contacto, NuevaImagen: {
                                                            name: e.target.value,
                                                            url: URL.createObjectURL(e.target.files[0]),
                                                            file: e.target.files[0],
                                                          }
                                                        };
                                                      }
                                                      return contacto;
                                                    });
                                                    setContactListFilter(editImagen); // actualiza el estado con el nuevo array
                                                  }
                                                }}
                                              />
                                            )}
                                          <div style={{ marginLeft: "15px" }}>
                                            <h4 style={{ textAlign: "center", marginTop: '10px', color: "gray" }}>
                                              {"ID YGIA: " + item.IdContacto}
                                            </h4>
                                          </div>
                                        </Row>

                                        <InputAntd
                                          value={item.Nombre}
                                          setStateValue={(value) => {
                                            changeValueInput(item.IdContacto, value, "Nombre")
                                          }}
                                          label="Nombre:"
                                          style={{ margin: "1% 0", background: "white" }}
                                          placeholder="Escribe tu nombre"
                                          setStateError={(value) => {
                                            manageError("Nombre", value, item.IdContacto);
                                          }}
                                          textError={["Debe escribir un nombre", "Solo se permiten letras (max. 20 caracteres)"]}
                                          type="text"
                                          valueError={errors[item.IdContacto]?.Nombre}
                                          vacio={false}
                                          disabled={!editMode[item.IdContacto]}
                                          expresionRegular={Expresiones.Letras}
                                          maxLength={40}
                                        />

                                        <InputAntd
                                          value={item.ApellidoPaterno}
                                          setStateValue={(value) => {
                                            changeValueInput(item.IdContacto, value, "ApellidoPaterno")
                                          }}
                                          label="Apellido paterno:"
                                          style={{ margin: "1% 0", background: "white" }}
                                          placeholder="Escribe tu primer apellido"
                                          setStateError={(value) => {
                                            manageError("ApellidoPaterno", value, item.IdContacto);
                                          }}
                                          textError={["Debe escribir un apellido", "Solo se permiten letras (max. 20 caracteres)"]}
                                          type="text"
                                          valueError={errors[item.IdContacto]?.ApellidoPaterno}
                                          vacio={false}
                                          disabled={!editMode[item.IdContacto]}
                                          expresionRegular={Expresiones.Letras}
                                          maxLength={20}
                                        />

                                        <InputAntd
                                          value={item.ApellidoMaterno}
                                          setStateValue={(value) => { changeValueInput(item.IdContacto, value, "ApellidoMaterno"); }}
                                          label="Apellido materno:"
                                          style={{ margin: "1% 0", background: "white" }}
                                          placeholder="Escribe tu segundo apellido"
                                          setStateError={(value) => { manageError("ApellidoMaterno", value, item.IdContacto); }}
                                          textError={["", "Solo se permiten letras (max. 20 caracteres)"]}
                                          type="text"
                                          valueError={errors[item.IdContacto]?.ApellidoMaterno}
                                          vacio={true}
                                          disabled={!editMode[item.IdContacto]}
                                          expresionRegular={Expresiones.Letras}
                                          maxLength={20}
                                        />
                                      </Col>
                                      <Col sm={{ flex: "50%" }} style={{ padding: "0 7px" }}>
                                        <SelectAntd
                                          label="Tipo de contacto:"
                                          value={item.Type !== null ? item.Type.toString() : null}
                                          style={{ width: "100%", margin: "0 0 5px 0", background: "white" }}
                                          placeholder="Tipo de contacto"
                                          options={[
                                            { value: "4", label: "Asistente" },
                                          ]}
                                          setStateValue={(value) => { changeValueInput(item.IdContacto, parseInt(value), "Type"); }}
                                          valueError={errors[item.IdContacto]?.Type}
                                          disabled={item.Type === 4 || item.YgiaUser === "Con Ygia" ? true : !editMode[item.IdContacto]}
                                        />


                                        <InputAntd
                                          value={item.Celular}
                                          setStateValue={(value) => { changeValueInput(item.IdContacto, value, "Celular"); }}
                                          label="Celular:"
                                          id="celular"
                                          style={{ margin: "1% 0", background: "white" }}
                                          placeholder="Escribe tu celular"
                                          setStateError={(value) => { manageError("Celular", value, item.IdContacto); }}
                                          textError={["", "Celular solo puede contener numeros", "Celular debe contener 10 dígitos"]}
                                          type="text"
                                          valueError={errors[item.IdContacto]?.Celular}
                                          vacio={true}
                                          disabled={!editMode[item.IdContacto]}
                                          expresionRegular={Expresiones.Numeros}
                                          maxLength={10}
                                        />

                                        <InputAntd
                                          value={item.Email}
                                          setStateValue={(value) => { changeValueInput(item.IdContacto, value, "Email"); }}
                                          label="Correo:"
                                          style={{ margin: "1% 0", background: "white" }}
                                          placeholder="Escribe tu correo eléctronico"
                                          setStateError={(value) => { manageError("Email", value, item.IdContacto); }}
                                          textError={["", "Formato incorrecto"]}
                                          type="text"
                                          valueError={errors[item.IdContacto]?.Email}
                                          vacio={true}
                                          disabled={!editMode[item.IdContacto]}
                                          expresionRegular={Expresiones.Correo}
                                        />

                                        <TextAreaAntd
                                          label="Comentarios o notas:"
                                          value={item.Nota}
                                          placeholder="Escriba un comentario o nota (opcional)"
                                          style={{
                                            marginTop: "7px",
                                            fontFamily: "sans-serif",
                                            background: "white"
                                          }}
                                          columns="30"
                                          autoSize={true}
                                          disabled={!editMode[item.IdContacto]}
                                          setStateValue={(value) => { changeValueInput(item.IdContacto, value, "Nota"); }}
                                        />
                                      </Col>

                                      {editMode[item.IdContacto] && (
                                        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", width: "100%" }}>
                                          <Button
                                            className="roundedButtonBlue buttons-add-contact"
                                            style={{ marginRight: "10px" }}
                                            loading={loaderEditContact}
                                            onClick={(e) => { newEditContact(e, item.IdContacto) }}
                                          >
                                            Guardar
                                          </Button>

                                          <Button
                                            className="roundedButtonWhite buttons-add-contact"
                                            style={{ marginLeft: "10px" }}
                                            loading={loaderEditContact}
                                            onClick={() => { cancelEdit(item); }}
                                          >
                                            Cancelar
                                          </Button>
                                        </div>
                                      )}
                                    </Row>
                                  </div>
                                )

                              }
                            ]}
                          />
                        </List.Item>
                      )}
                    />
                  )}
                </div>
              </TabPane>
            )}

          </Tabs>
        </ConfigProvider>
      </div>

      <Modal
        title={<h3 style={{ color: "white", padding: "5px 0 5px 15px" }}>Nuevo contacto</h3>}
        closeIcon={<CloseOutlined style={{ color: 'white', marginBottom: "10px" }} onClick={() => CloseModalAddContacto(true)} />}
        open={isOpenModalAddContacto}
        width={"70%"}
        footer={false}
        styles={{ header: { backgroundColor: "#148f9f", color: "white", height: "40px", borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }, body: { padding: "3%" }, content: { padding: "0", borderRadius: "20px" } }}
      >
        {loaderAddContact ? (
          <LoaderModals />
        ) : (
          <>
            <Row>
              <Col sm={{ flex: "50%" }}>
                <div style={{ display: "flex", justifyContent: "center", width: "95%", margin: "2% 0" }}>
                  <label htmlFor="imagenContacto2">
                    <img
                      style={{ cursor: "pointer" }}
                      className="imagencont"
                      src={!!AddProfileImage.url ? AddProfileImage.url : iconos[19]}
                    />
                  </label>
                  <input
                    type="file"
                    id="imagenContacto2"
                    accept="/image/x-PNG,image/jpeg"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file && file.type.substring(0, 5) === "image") {
                        setAddProfileImage({
                          name: e.target.value,
                          url: URL.createObjectURL(e.target.files[0]),
                          file: e.target.files[0],
                        });
                      } else {
                        setOpen(true);
                        setTypeMessage("error");
                        setMessage("Tipo de archivo no válido");
                      }
                    }}
                  />
                </div>
                <InputAntd
                  value={AddNombre}
                  setStateValue={setAddNombre}
                  label="Nombre:"
                  style={{ margin: "2% 0", width: "95%" }}
                  placeholder="Escribe tu nombre"
                  setStateError={setMensajeAddNombre}
                  textError={["Debe escribir un nombre", "Solo se permiten letras (max. 20 caracteres)"]}
                  type="text"
                  valueError={MensajeAddNombre}
                  vacio={false}
                  disabled={false}
                  expresionRegular={Expresiones.Letras}
                  maxLength={40}
                />

                <InputAntd
                  value={AddApellidoP}
                  setStateValue={setAddApellidoP}
                  label="Apellido Paterno:"
                  style={{ margin: "2% 0", width: "95%" }}
                  placeholder="Escribe tu primer apellido"
                  setStateError={setMensajeAddApellidoP}
                  textError={["Debe escribir un apellido paterno", "Solo se permiten letras (max. 20 caracteres)"]}
                  type="text"
                  valueError={MensajeAddApellidoP}
                  vacio={false}
                  disabled={false}
                  expresionRegular={Expresiones.Letras}
                  maxLength={20}
                />

                <InputAntd
                  value={AddApellidoM}
                  setStateValue={setAddApellidoM}
                  label="Apellido Materno:"
                  style={{ margin: "2% 0", width: "95%" }}
                  placeholder="Escribe tu segundo apellido"
                  setStateError={setMensajeAddApellidoM}
                  textError={["", "Solo se permiten letras (max. 20 caracteres)"]}
                  type="text"
                  valueError={MensajeAddApellidoM}
                  vacio={true}
                  disabled={false}
                  expresionRegular={Expresiones.Letras}
                  maxLength={20}
                />
              </Col>

              <Col sm={{ flex: "50%" }}>
                <SelectAntd
                  label="Tipo de contacto:"
                  value={AddTipocontacto}
                  style={{ margin: "2% 0", width: "100%" }}
                  placeholder="Selecciona un tipo"
                  options={[
                    { value: "1", label: "Médico" },
                    { value: "3", label: "Paciente" },
                  ]}
                  setStateValue={setAddTipocontacto}
                  setStateError={setComboAddTipo}
                  valueError={comboAddTipo}
                  disabled={false}
                />

                {AddTipocontacto === "1" && (
                  <InputAntd
                    value={AddEspecialidad}
                    setStateValue={setAddEspecialidad}
                    label="Especialidad:"
                    style={{ margin: "2% 0" }}
                    placeholder="Escriba una especialidad"
                    setStateError={setMensajeAddEspecialidad}
                    textError={["Debe escribir una especialidad", "Solo se permiten letras (max. 20 caracteres)"]}
                    type="text"
                    valueError={MensajeAddEspecialidad}
                    vacio={false}
                    disabled={false}
                    expresionRegular={Expresiones.Letras}
                    maxLength={30}
                  />
                )}

                <InputAntd
                  value={AddCelular}
                  setStateValue={setAddCelular}
                  label="Celular"
                  id="celular"
                  style={{ margin: "2% 0 2% 0" }}
                  placeholder="Escribe tu celular"
                  setStateError={setMensajeAddCelular}
                  textError={["", "Celular solo puede contener numeros", "Celular debe contener 10 dígitos"]}
                  type="text"
                  valueError={MensajeAddCelular}
                  vacio={true}
                  disabled={false}
                  expresionRegular={Expresiones.Numeros}
                  maxLength={10}
                />

                <InputAntd
                  value={AddCorreo}
                  setStateValue={setAddCorreo}
                  label="Correo"
                  style={{ margin: "2% 0 2% 0" }}
                  placeholder="Escribe tu correo eléctronico"
                  setStateError={setMensajeAddCorreo}
                  textError={["", "Formato incorrecto"]}
                  type="text"
                  valueError={MensajeAddCorreo}
                  vacio={true}
                  disabled={false}
                  expresionRegular={Expresiones.Correo}
                />

                <TextAreaAntd
                  label="Comentarios o notas:"
                  value={AddNotaContacto}
                  placeholder="Escriba un comentario o nota (opcional)"
                  style={{
                    // marginBottom: ".5%",
                    margin: "2% 0 2% 0",
                    fontFamily: "sans-serif",
                  }}
                  columns="30"
                  autoSize={true}
                  setStateValue={setAddNotaContacto}
                />
              </Col>
            </Row>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button loading={loaderAddContact} style={{ width: "150px", paddingBlock: "20px" }} className="roundedButtonBlue" onClick={(e) => { saveContact(e); }}>
                Guardar
              </Button>
            </div>
          </>
        )}
      </Modal>

      {ModalEliminarContacto}

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={typeMessage}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>

    </Stack >
  );
}